import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import bannerImage from "../assets/img/ban1.jpg";
import "../assets/css/style.css";

// Static data
const companySizes = ["1-10", "11-50", "51-200", "201-500", "501+"];
const companyRevenues = ["< $1M", "$1M-$10M", "$10M-$50M", "$50M-$100M", "$100M+"];
const industries = [
  { name: "Technology", sub: ["Software", "Hardware", { name: "AI", sub: ["Machine Learning", "NLP"] }] },
  { name: "Finance", sub: ["Banking", "Insurance"] },
  { name: "Healthcare", sub: ["Pharma", "Medical Devices"] },
];
const companies = [
  {
    company_id: "C001",
    company_name: "TechCorp",
    company_url: "www.techcorp.com",
    industry: "Technology > Software",
    headquarter_country: "USA",
    ceo: "John Doe",
    company_status: 1,
    logo: "techcorp.png",
  },
  {
    company_id: "C002",
    company_name: "Innovate Inc",
    company_url: "www.innovateinc.com",
    industry: "Finance > Banking",
    headquarter_country: "Canada",
    ceo: "Jane Smith",
    company_status: 2,
    logo: "innovate.png",
  },
  {
    company_id: "C002",
    company_name: "Innovate Inc",
    company_url: "www.innovateinc.com",
    industry: "Finance > Banking",
    headquarter_country: "Canada",
    ceo: "Jane Smith",
    company_status: 2,
    logo: "innovate.png",
  },
  {
    company_id: "C002",
    company_name: "Innovate Inc",
    company_url: "www.innovateinc.com",
    industry: "Finance > Banking",
    headquarter_country: "Canada",
    ceo: "Jane Smith",
    company_status: 2,
    logo: "innovate.png",
  },
  
];

const ITEMS_PER_PAGE = 15;

// Pagination Component
const Pagination = ({ currentPage, totalPages, handlePageChange }) => {
  const pageGroup = Math.ceil(currentPage / 3);
  const startPage = (pageGroup - 1) * 3 + 1;
  const endPage = Math.min(startPage + 2, totalPages);
  const pageNumbers = Array.from(
    { length: endPage - startPage + 1 },
    (_, i) => startPage + i
  );

  return (
    <nav aria-label="Page navigation" className="mt-4">
      <ul className="pagination justify-content-center">
        <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
          <button
            className="page-link"
            onClick={() => handlePageChange(currentPage - 1)}
          >
            Previous
          </button>
        </li>
        {pageNumbers.map((page) => (
          <li
            key={page}
            className={`page-item ${currentPage === page ? "active" : ""}`}
          >
            <button
              className="page-link"
              onClick={() => handlePageChange(page)}
            >
              {page}
            </button>
          </li>
        ))}
        <li className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}>
          <button
            className="page-link"
            onClick={() => handlePageChange(currentPage + 1)}
          >
            Next
          </button>
        </li>
      </ul>
    </nav>
  );
};

// Main CompanyPanel Component
const CompanyPanel = () => {
  const [filters, setFilters] = useState({
    companyName: "",
    CompanyURL: "",
    CEO: "",
    searchStatus: "",
    headquarter: "",
    naics_code: "",
    start: "",
    end: "",
    employee_size: [],
    company_revenue: [],
    sector_and_industry: "",
  });
  const [filteredCompanies, setFilteredCompanies] = useState(companies);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(Math.ceil(companies.length / ITEMS_PER_PAGE));
  const [industrySearch, setIndustrySearch] = useState("");
  const [isIndustryDropdownOpen, setIsIndustryDropdownOpen] = useState(false);
  const industryDropdownRef = useRef(null);
  const navigate = useNavigate();

  // Fix white space and ensure full-page layout
  useEffect(() => {
    document.body.style.margin = '0';
    document.body.style.padding = '0';
    document.documentElement.style.margin = '0';
    document.documentElement.style.padding = '0';
    document.body.style.overflowX = 'hidden';
    document.documentElement.style.overflowX = 'hidden';

    return () => {
      document.body.style.margin = '';
      document.body.style.padding = '';
      document.documentElement.style.margin = '';
      document.documentElement.style.padding = '';
      document.body.style.overflowX = '';
      document.documentElement.style.overflowX = '';
    };
  }, []);

  // Handle clicks outside industry dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (industryDropdownRef.current && !industryDropdownRef.current.contains(event.target)) {
        setIsIndustryDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Filter companies based on search criteria
  useEffect(() => {
    const filtered = companies.filter((company) => {
      const matchesCompanyName = filters.companyName
        ? company.company_name.toLowerCase().includes(filters.companyName.toLowerCase())
        : true;
      const matchesCompanyURL = filters.CompanyURL
        ? company.company_url.toLowerCase().includes(filters.CompanyURL.toLowerCase())
        : true;
      const matchesCEO = filters.CEO
        ? company.ceo.toLowerCase().includes(filters.CEO.toLowerCase())
        : true;
      const matchesStatus = filters.searchStatus
        ? company.company_status.toString() === filters.searchStatus
        : true;
      const matchesHeadquarter = filters.headquarter
        ? company.headquarter_country.toLowerCase().includes(filters.headquarter.toLowerCase())
        : true;
      const matchesNaicsCode = filters.naics_code
        ? company.naics_code?.toLowerCase().includes(filters.naics_code.toLowerCase())
        : true;
      const matchesEmployeeSize =
        filters.employee_size.length > 0
          ? filters.employee_size.includes(company.employee_size)
          : true;
      const matchesRevenue =
        filters.company_revenue.length > 0
          ? filters.company_revenue.includes(company.company_revenue)
          : true;
      const matchesIndustry = filters.sector_and_industry
        ? company.industry === filters.sector_and_industry
        : true;
      const matchesDateRange = true;

      return (
        matchesCompanyName &&
        matchesCompanyURL &&
        matchesCEO &&
        matchesStatus &&
        matchesHeadquarter &&
        matchesNaicsCode &&
        matchesEmployeeSize &&
        matchesRevenue &&
        matchesIndustry &&
        matchesDateRange
      );
    });

    setFilteredCompanies(filtered);
    setTotalPages(Math.ceil(filtered.length / ITEMS_PER_PAGE));
    setCurrentPage(1);
  }, [filters]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleMultiSelectChange = (e) => {
    const { name, options } = e.target;
    const values = Array.from(options)
      .filter((opt) => opt.selected)
      .map((opt) => opt.value);
    setFilters((prev) => ({ ...prev, [name]: values }));
  };

  const handleIndustrySelect = (value) => {
    setFilters((prev) => ({ ...prev, sector_and_industry: value }));
    setIsIndustryDropdownOpen(false);
    setIndustrySearch("");
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const clearFilters = () => {
    setFilters({
      companyName: "",
      CompanyURL: "",
      CEO: "",
      searchStatus: "",
      headquarter: "",
      naics_code: "",
      start: "",
      end: "",
      employee_size: [],
      company_revenue: [],
      sector_and_industry: "",
    });
    setIndustrySearch("");
  };

  const filteredIndustries = industries.filter((industry) => {
    const searchLower = industrySearch.toLowerCase();
    return (
      industry.name.toLowerCase().includes(searchLower) ||
      industry.sub.some((sub) =>
        typeof sub === "string"
          ? sub.toLowerCase().includes(searchLower)
          : sub.name.toLowerCase().includes(searchLower) ||
            sub.sub.some((subSub) => subSub.toLowerCase().includes(searchLower))
      )
    );
  });

  const paginatedCompanies = filteredCompanies.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const handleAddCompany = () => {
    navigate("/addcompany");
  };

  return (
    <div
      id="page-top"
      className="sidebar-toggled"
      style={{
        minHeight: '100vh',
        width: '100%',
        margin: 0,
        padding: 0,
        background: `linear-gradient(rgba(20,20,20,0.8), rgba(20,20,20,0.8)), url(${bannerImage}) center/cover no-repeat`,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div id="wrapper" className="flex-grow-1 d-flex flex-column">
        <div id="content" className="flex-grow-1">
          <div
            className="container-fluid"
            id="contentfluid"
            style={{ padding: '40px 30px' }}
          >
            {/* Header Section */}
            <div className="d-sm-flex align-items-center justify-content-between mb-4 pt-4">
              <h1 className="text-white display-4 fw-bold">Company Panel</h1>
              {/* <button
                style={{
                  padding: "10px 20px",
                  borderRadius: "25px",
                  background: "#2f8c8e",
                  color: "#fff",
                  border: "none",
                  fontSize: "0.875rem",
                  cursor: "pointer",
                }}
                onClick={handleAddCompany}
              >
                <i className="bi bi-plus"></i> Add New Company
              </button> */}
            </div>

            {/* Main Content */}
            <div className="row">
              {/* Sidebar with Filters */}
              <div className="col-lg-4 col-xl-4">
                <aside id="asidebar_inner" className="ft-15 lh-22">
                  <div className="first_box card_box">
                    <form
                      className="position-relative search_aside"
                      onSubmit={(e) => e.preventDefault()}
                    >
                      <i className="bi bi-search"></i>
                      <input
                        type="text"
                        name="companyName"
                        className="form-control"
                        placeholder="Search by Company Name"
                        value={filters.companyName}
                        onChange={handleInputChange}
                      />
                      {filters.companyName && (
                        <button
                          className="btn btn-secondary"
                          style={{ position: "absolute", right: "10px", top: "50%", transform: "translateY(-50%)" }}
                          onClick={() =>
                            handleInputChange({
                              target: { name: "companyName", value: "" },
                            })
                          }
                        >
                          Clear
                        </button>
                      )}
                    </form>
                    <div className="d-flex justify-content-between mt-3">
                      <h4 className="fw-700">Filters</h4>
                      <a
                        href="#"
                        className="color746E6E"
                        onClick={(e) => {
                          e.preventDefault();
                          clearFilters();
                        }}
                      >
                        Clear all
                      </a>
                    </div>
                  </div>
                  <div className="card_box color-555">
                    <div className="search_criteria">
                      <div className="accordion" id="filterAccordion">
                        {[
                          {
                            id: "CompanyURL",
                            icon: "bi-link",
                            title: "Company URL",
                            name: "CompanyURL",
                            placeholder: "Enter Company URL",
                          },
                          {
                            id: "CEO",
                            icon: "bi-person",
                            title: "CEO",
                            name: "CEO",
                            placeholder: "Enter CEO Name",
                          },
                          {
                            id: "headquarter",
                            icon: "bi-geo-alt",
                            title: "Headquarter",
                            name: "headquarter",
                            placeholder: "Enter Headquarter Country",
                          },
                        ].map((filter) => (
                          <div className="accordion-item" key={filter.id}>
                            <h2
                              className="accordion-header"
                              id={`heading${filter.id}`}
                            >
                              <button
                                className="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target={`#collapse${filter.id}`}
                                aria-expanded="false"
                                aria-controls={`collapse${filter.id}`}
                              >
                                <i
                                  className={`bi ${filter.icon}`}
                                  style={{ marginRight: "8px", fontSize: "1rem" }}
                                  aria-hidden="true"
                                ></i>
                                {filter.title}
                              </button>
                            </h2>
                            <div
                              id={`collapse${filter.id}`}
                              className="accordion-collapse collapse"
                              aria-labelledby={`heading${filter.id}`}
                              data-bs-parent="#filterAccordion"
                            >
                              <div className="accordion-body">
                                <div style={{ display: "flex", gap: "10px" }}>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name={filter.name}
                                    placeholder={filter.placeholder}
                                    value={filters[filter.name]}
                                    onChange={handleInputChange}
                                  />
                                  {filters[filter.name] && (
                                    <button
                                      className="btn btn-secondary"
                                      onClick={() =>
                                        handleInputChange({
                                          target: { name: filter.name, value: "" },
                                        })
                                      }
                                    >
                                      Clear
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                        {[
                          {
                            id: "searchStatus",
                            icon: "bi-check-circle",
                            title: "Status",
                            name: "searchStatus",
                            options: [
                              { value: "1", label: "Verified" },
                              { value: "2", label: "Pending For Verification" },
                              { value: "3", label: "API Update" },
                            ],
                          },
                          {
                            id: "employee_size",
                            icon: "bi-people",
                            title: "Employee Size",
                            name: "employee_size",
                            options: companySizes,
                          },
                          {
                            id: "company_revenue",
                            icon: "bi-currency-dollar",
                            title: "Company Revenue",
                            name: "company_revenue",
                            options: companyRevenues,
                          },
                        ].map((filter) => (
                          <div className="accordion-item" key={filter.id}>
                            <h2
                              className="accordion-header"
                              id={`heading${filter.id}`}
                            >
                              <button
                                className="accordion-button collapsed"
                                type="button"
                                data-bs-toggle="collapse"
                                data-bs-target={`#collapse${filter.id}`}
                                aria-expanded="false"
                                aria-controls={`collapse${filter.id}`}
                              >
                                <i
                                  className={`bi ${filter.icon}`}
                                  style={{ marginRight: "8px", fontSize: "1rem" }}
                                  aria-hidden="true"
                                ></i>
                                {filter.title}
                              </button>
                            </h2>
                            <div
                              id={`collapse${filter.id}`}
                              className="accordion-collapse collapse"
                              aria-labelledby={`heading${filter.id}`}
                              data-bs-parent="#filterAccordion"
                            >
                              <div className="accordion-body">
                                <div style={{ display: "flex", gap: "10px" }}>
                                  <select
                                    className="form-control"
                                    name={filter.name}
                                    multiple={filter.name !== "searchStatus"}
                                    value={filters[filter.name]}
                                    onChange={
                                      filter.name === "searchStatus"
                                        ? handleInputChange
                                        : handleMultiSelectChange
                                    }
                                  >
                                    <option value="">Select {filter.title}</option>
                                    {filter.options.map((option, index) => (
                                      <option
                                        key={index}
                                        value={typeof option === "string" ? option : option.value}
                                      >
                                        {typeof option === "string" ? option : option.label}
                                      </option>
                                    ))}
                                  </select>
                                  {(filter.name === "searchStatus" ? filters[filter.name] : filters[filter.name].length > 0) && (
                                    <button
                                      className="btn btn-secondary"
                                      onClick={() =>
                                        filter.name === "searchStatus"
                                          ? handleInputChange({
                                              target: { name: filter.name, value: "" },
                                            })
                                          : handleMultiSelectChange({
                                              target: { name: filter.name, options: [] },
                                            })
                                      }
                                    >
                                      Clear
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                        {/* Industry Filter */}
                        <div className="accordion-item">
                          <h2 className="accordion-header" id="headingIndustry">
                            <button
                              className="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseIndustry"
                              aria-expanded="false"
                              aria-controls="collapseIndustry"
                            >
                              <i
                                className="bi bi-briefcase"
                                style={{ marginRight: "8px", fontSize: "1rem" }}
                                aria-hidden="true"
                              ></i>
                              Industry
                            </button>
                          </h2>
                          <div
                            id="collapseIndustry"
                            className="accordion-collapse collapse"
                            aria-labelledby="headingIndustry"
                            data-bs-parent="#filterAccordion"
                          >
                            <div className="accordion-body">
                              <div style={{ display: "flex", gap: "10px" }} ref={industryDropdownRef}>
                                <div className="dropdown" style={{ position: "relative", width: "100%" }}>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Search Industry"
                                    value={industrySearch}
                                    onChange={(e) => setIndustrySearch(e.target.value)}
                                    onFocus={() => setIsIndustryDropdownOpen(true)}
                                  />
                                  {isIndustryDropdownOpen && (
                                    <ul
                                      className="dropdown-menu show"
                                      style={{
                                        maxHeight: "200px",
                                        overflowY: "auto",
                                        width: "100%",
                                        fontSize: "14px",
                                        border: "1px solid #ccc",
                                      }}
                                    >
                                      {filteredIndustries.length > 0 ? (
                                        filteredIndustries.map((industry) => (
                                          <li key={industry.name}>
                                            <div
                                              className="dropdown-item"
                                              style={{ cursor: "pointer", fontWeight: "bold" }}
                                              onClick={() => handleIndustrySelect(industry.name)}
                                            >
                                              {industry.name}
                                            </div>
                                            {industry.sub.map((sub, subIndex) =>
                                              typeof sub === "string" ? (
                                                <ul key={subIndex} style={{ listStyle: "none", paddingLeft: "15px" }}>
                                                  <li
                                                    className="dropdown-item"
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => handleIndustrySelect(`${industry.name} > ${sub}`)}
                                                  >
                                                    {sub}
                                                  </li>
                                                </ul>
                                              ) : (
                                                <ul key={subIndex} style={{ listStyle: "none", paddingLeft: "15px" }}>
                                                  <li
                                                    className="dropdown-item"
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => handleIndustrySelect(`${industry.name} > ${sub.name}`)}
                                                  >
                                                    {sub.name}
                                                  </li>
                                                  {sub.sub.map((subSub, subSubIndex) => (
                                                    <ul
                                                      key={subSubIndex}
                                                      style={{ listStyle: "none", paddingLeft: "15px" }}
                                                    >
                                                      <li
                                                        className="dropdown-item"
                                                        style={{ cursor: "pointer" }}
                                                        onClick={() =>
                                                          handleIndustrySelect(
                                                            `${industry.name} > ${sub.name} > ${subSub}`
                                                          )
                                                        }
                                                      >
                                                        {subSub}
                                                      </li>
                                                    </ul>
                                                  ))}
                                                </ul>
                                              )
                                            )}
                                          </li>
                                        ))
                                      ) : (
                                        <li className="dropdown-item">No industries found</li>
                                      )}
                                    </ul>
                                  )}
                                </div>
                                {filters.sector_and_industry && (
                                  <button
                                    className="btn btn-secondary"
                                    onClick={() => handleIndustrySelect("")}
                                  >
                                    Clear
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </aside>
              </div>

              {/* Main Content */}
              <div className="col-lg-8">
                <div className="inner_wrapper card_box py-5">
                  {/* Header with Actions */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginBottom: "20px",
                      padding: "0 15px",
                    }}
                  >
                    <h1 style={{ fontSize: "1.75rem", fontWeight: "bold", color: "#333" }}>
                      Company Details
                    </h1>
                    <button
                      style={{
                        padding: "10px 20px",
                        borderRadius: "25px",
                        background: "#2f8c8e",
                        color: "#fff",
                        border: "none",
                        fontSize: "0.875rem",
                        cursor: "pointer",
                      }}
                      onClick={handleAddCompany}
                    >
                      <i className="bi bi-plus"></i> Add New Company
                    </button>
                  </div>

                  {/* Company Table */}
                  <div className="tab-content pt-3">
                    <div className="tab-pane fade show active">
                      <section className="table_section table-responsive">
                        <div className="card-header py-3">
                          <h5 className="m-0 font-weight-bold" style={{ color: "#2f8c8e" }}>
                            Company List
                          </h5>
                          <h6 className="m-0 font-weight-bold" style={{ color: "#2f8c8e" }}>
                            Verified = {filteredCompanies.filter(c => c.company_status === 1).length}
                          </h6>
                          <h6 className="m-0 font-weight-bold" style={{ color: "#2f8c8e" }}>
                            Pending = {filteredCompanies.filter(c => c.company_status === 2).length}
                          </h6>
                        </div>
                        <table className="custom-table">
                          <thead>
                            <tr>
                              <th scope="col">Company Name</th>
                              <th scope="col">Company URL</th>
                              <th scope="col">Industry</th>
                              <th scope="col">Head Quarter Country</th>
                              <th scope="col">CEO</th>
                              <th scope="col">Status</th>
                              <th scope="col">View</th>
                              <th scope="col">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {paginatedCompanies.length > 0 ? (
                              paginatedCompanies.map((company) => (
                                <tr key={company.company_id}>
                                  <td>
                                    <img
                                      src={`/public/company-logo-images/${company.logo || ""}`}
                                      alt=""
                                      style={{ width: "20px", verticalAlign: "middle", marginRight: "8px" }}
                                      onError={(e) => (e.target.style.display = "none")}
                                    />
                                    <span>{company.company_name || "NA"}</span>
                                  </td>
                                  <td>
                                    <a href={`http://${company.company_url}`} target="_blank" rel="noopener noreferrer">
                                      {company.company_url || "NA"}
                                    </a>
                                  </td>
                                  <td title={company.industry || "NA"}>
                                    {company.industry?.length > 24
                                      ? company.industry.substring(0, 24) + "..."
                                      : company.industry || "NA"}
                                  </td>
                                  <td>{company.headquarter_country || "NA"}</td>
                                  <td>
                                    <a href={company.ceo_url || "#"} target="_blank" rel="noopener noreferrer">
                                      {company.ceo || "NA"}
                                    </a>
                                  </td>
                                  <td
                                    style={{
                                      color:
                                        company.company_status === 1
                                          ? "green"
                                          : company.company_status === 2
                                          ? "black"
                                          : company.company_status === 3
                                          ? "red"
                                          : "black",
                                    }}
                                  >
                                    {company.company_status === 1
                                      ? "Verified"
                                      : company.company_status === 2
                                      ? "Pending For Verification"
                                      : company.company_status === 3
                                      ? "API Update"
                                      : "NA"}
                                  </td>
                                  <td>
                                    <Link to={`/company-detail/${company.company_id}`}>
                                      <i className="bi bi-eye" aria-hidden="true"></i>
                                    </Link>
                                  </td>
                                  <td>
                                    <Link to={`/editcompany/${company.company_id}`}>
                                      <i className="bi bi-pencil" aria-hidden="true"></i>
                                    </Link>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="8" className="text-center">
                                  No companies found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </section>
                      <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        handlePageChange={handlePageChange}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <a className="scroll-to-top rounded" href="#page-top">
          <i className="fas fa-angle-up"></i>
        </a>
      </div>
    </div>
  );
};

export default CompanyPanel;